import script from "./ReviewsBlock.vue?vue&type=script&setup=true&lang=js"
export * from "./ReviewsBlock.vue?vue&type=script&setup=true&lang=js"

import "./ReviewsBlock.vue?vue&type=style&index=0&id=f63f6f82&lang=scss"

const __exports__ = script;

export default __exports__